(function($) {
    $(() => {
        window.formSubmit = function() {
            if (grecaptcha.getResponse() !== '') {
                $('form').submit();
            }

            grecaptcha.reset();
        };

        const hasLetterRegex = '[a-zA-ZÀ-ÖØ-öø-ÿ+-]';

        let block_submit_twice = false;

        function removeLetters(string) {
            const r = new RegExp(hasLetterRegex, 'g');
            return string.replace(r, '');
        }

        $('#contact_form').submit(function(e) {
            e.preventDefault();

            $('.button__wrapper').addClass('d-none');

            const theForm = $(this);

            const data = grabFormAsObject(theForm);

            $.ajax({
                url: localize.ajax_url,
                type: 'POST',
                data: {
                    action: 'submit_form',
                    data
                },

                error(response) {
                    $('.button__wrapper').css('display', 'none');
                },

                success(response) {
                    $('.button__wrapper').css('display', 'none');
                    block_submit_twice = false;
                    $(':input', '#contact_form')
                        .not(':button, :submit, :reset, :hidden')
                        .val('')
                        .prop('checked', false)
                        .prop('selected', false);
                    $('.submit_success').removeClass('d-none');
                }
            });
        });
    });
})(jQuery);

(function($) {
    $(() => {
        function validateJsFormRequire(jqueryForm, shouldShow, limitToFields = []) {
            let hasError = false;
            jqueryForm
                .parents('form')
                .find('[required],.show-required')
                .each(function(el) {
                    if (
                        !jQuery(this).val() ||
                        (jQuery(this).attr('type') === 'email' &&
                            !validateEmail(jQuery(this).val())) ||
                        (jQuery(this).attr('type') === 'checkbox' &&
                            jQuery(this).prop('checked') == false)
                    ) {
                        jQuery(this)
                            .parents('.form__item')
                            .toggleClass('has--error', shouldShow);
                        if (
                            limitToFields.length > 0 &&
                            limitToFields.indexOf(jQuery(this).attr('name')) !== -1
                        ) {
                            hasError = true;
                        }
                    }
                });

            return hasError;
        }

        const lineEq = (y2, y1, x2, x1, currentVal) => {
            // y = mx + b
            const m = (y2 - y1) / (x2 - x1);
            const b = y1 - m * x1;
            return m * currentVal + b;
        };

        const distanceThreshold = { min: 0, max: 75 };
        const opacityInterval = { from: 0, to: 1 };

        $('.js-form-submit').each(function() {
            const $that = $(this);

            new Nearby($that[0], {
                onProgress: distance => {
                    const o = lineEq(
                        opacityInterval.from,
                        opacityInterval.to,
                        distanceThreshold.max,
                        distanceThreshold.min,
                        distance
                    );
                    validateJsFormRequire($that, o == 1);
                }
            });
        });
    });

    $('input[type=radio]').click(function() {
        if (this.previous) {
            this.checked = false;
        }
        this.previous = this.checked;
    });
})(jQuery);
